var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-select', _vm._g(_vm._b({ attrs: { "remote-method": _vm.handleRemote, "loading": _vm.loading }, model: { value: _vm.formValue[_vm.config.prop], callback: function callback($$v) {
        _vm.$set(_vm.formValue, _vm.config.prop, $$v);
      }, expression: "formValue[config.prop]" } }, 'el-select', _vm.innerConfig.params, false), _vm.$listeners), _vm._l(_vm.innerConfig.params.options, function (item) {
    return _c('el-option', { key: item.value, attrs: { "label": item.label, "value": item.value } }, [_c('span', { staticClass: "u-custom-select-id" }, [_vm._v(_vm._s(item.value))]), _vm._v(" "), _c('span', { staticClass: "m-custom-select-wrap" }, [_c('span', { staticClass: "u-custom-select-name" }, [_vm._v(_vm._s(item.label))])])]);
  }), 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };